import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import ChecklistCard from "./ChecklistCard";

export default function MustRefer({ IsMLS }) {
  const [ReferralDocs, setReferralDocs] = useState([
    "Referral Agreement (641)",
    "Full REALTOR® MLS SOLD Printout",
  ]);

  useEffect(() => {
    if (IsMLS === "Exclusive") {
      setReferralDocs(["Referral Document (641)"]);
    } else {
      setReferralDocs([
        "Referral Document (641)",
        "MLS Sheet (Full Agent Detail View)",
      ]);
    }
  }, [IsMLS]);

  return (
    <>
      <div className="clause-card-content must-refer-warning-wrap">
        <div className="clause-warning">
          <div className="clause-warning-icon">
            <FontAwesomeIcon icon={faTriangleExclamation} size="lg" />
          </div>
          <div>
            As per TRESA, you cannot represent both clients in a trade when you
            have interest (direct/indirect) in the transaction. As a result, you
            must release or refer one of the client(s) to another agent.
            However, you can collect a referral fee on the client referral.
          </div>
        </div>
      </div>

      <ChecklistCard
        CheckListData={ReferralDocs}
        Header={"Client Referral"}
        Title1="Referral Documents"
        province="ON"
      />
    </>
  );
}
